var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"view-shipping"}},[_c('admin-shipping',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedSearchItem),expression:"selectedSearchItem"}],ref:"theShipping",on:{"shippingupdated":_vm.reloadShipping}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }